import React from 'react'
import styled from 'styled-components'

import { CustomerInvoiceFragment } from '../../../../../graphql/camel'

const StyledAddressHeading = styled.div`
  margin-bottom: 16px;
`

const StyledAddress = styled.address`
  font-style: inherit;
`

export interface ShippingAndBillingProps {
  className?: string
  invoice: CustomerInvoiceFragment
}

const ShippingAndBilling: React.FC<ShippingAndBillingProps> = ({ className, invoice }) => {
  return (
    <div className={className}>
      {invoice.shippingAddress && (
        <div>
          <StyledAddressHeading>Shipping to:</StyledAddressHeading>
          <StyledAddress>
            <strong>{invoice.shippingAddress.addressee}</strong>
            <div>
              {invoice.shippingAddress.street.map((streetData) => (
                <span key={streetData}> {streetData}</span>
              ))}
            </div>
            <div>
              {invoice.shippingAddress.city}, {invoice.shippingAddress.state}{' '}
              {invoice.shippingAddress.countryCode} {invoice.shippingAddress.zip}
            </div>
          </StyledAddress>
        </div>
      )}
      {invoice.billingAddress && (
        <div>
          <StyledAddressHeading>Bill to:</StyledAddressHeading>
          <StyledAddress>
            <strong>{invoice.billingAddress.addressee}</strong>
            <div>
              {invoice.billingAddress.street.map((streetData) => (
                <span key={streetData}> {streetData}</span>
              ))}
            </div>
            <div>
              {invoice.billingAddress.city}, {invoice.billingAddress.state}{' '}
              {invoice.billingAddress.countryCode} {invoice.billingAddress.zip}
            </div>
          </StyledAddress>
        </div>
      )}
    </div>
  )
}

const StyledShippingAndBilling = styled(ShippingAndBilling)`
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: 1fr;
  gap: 30px;
  line-height: 1.25;

  @media (min-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }
`

export default StyledShippingAndBilling
